export const booleanOptions = [{ value: true, label: "Yes" }, { value: false, label: "No" }];
